<template>
  <div class="drama-grid">
    <div
      v-for="item in list"
      :key="item.id"
      class="drama-card"
      @click="$emit('item-click', item)"
    >
      <!-- 封面区域 -->
      <div class="card-cover">
        <!-- 底图：铺满 + 模糊，填补非标准比例产生的空白 -->
        <img class="bg-image" :src="item.img" alt="" />

        <!-- 主图：铺满容器（CSS object-fit 实现 cover） -->
        <img class="card-image" :src="item.img" alt="" />

        <div class="cover-time">📺{{ $t('video.totalEpisodes', { num: item.sum }) }}</div>
      </div>

      <!-- 信息区域 -->
      <div class="card-info">
        <div class="card-title">{{ item.name }}</div>
      </div>
    </div>

    <!-- 空状态 -->
    <div v-if="list.length === 0" class="empty-state">
      😢 {{$t("search.noWorks")}}
    </div>
  </div>
</template>

<script>
export default {
  props: ['list'],
  name:"ModuleVideoList",
};
</script>

<style scoped>
.drama-grid {
  padding: 12px 6px 18px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 18px 12px;
  background: transparent;
}

/* 卡片样式 */
.drama-card {
  min-width: 0;
  background: transparent;
  border-radius: 0;
  overflow: visible;
  box-shadow: none;
  transition: transform 0.12s ease;
  cursor: pointer;
  border: 0;
  display: flex;
  flex-direction: column;
}

.drama-card:active {
  transform: scale(0.98);
}

/* 封面区域：竖海报常用 2:3 比例 */
.card-cover {
  position: relative;
  width: 100%;
  height: 0;
  padding-bottom: 125%; /* 2:3 = 3/2 = 1.5，高度是宽度的150%？实际padding-bottom:150%才是2:3。125%是4:5，这里保持原比例 */
  background: #e5e5ea;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 3px 12px rgba(0, 0, 0, 0.07);
}

/* 底图：解决留白问题，模糊背景 */
.bg-image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  filter: blur(16px);
  transform: scale(1.15);
  opacity: 0.35;
  object-fit: cover; /* 确保图片覆盖容器 */
}

/* 主图：正常铺满 */
.card-image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover; /* 替代 uni-app mode="aspectFill" */
}

/* 角标 */
.cover-time {
  position: absolute;
  bottom: 7px;
  right: 7px;
  max-width: calc(100% - 14px);
  background: rgba(0, 0, 0, 0.62);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  color: white;
  font-size: 10px;
  font-weight: 500;
  padding: 4px 7px;
  border-radius: 999px;
  display: flex;
  align-items: center;
  border: 0;
  z-index: 2;
  white-space: nowrap;
  line-height: 1;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* 卡片信息 */
.card-info {
  padding: 9px 2px 0;
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.card-title {
  font-size: 13px;
  font-weight: 600;
  color: #1d1d1f;
  line-height: 1.4;
  letter-spacing: 0;
  margin-bottom: 0;

  display: -webkit-box;
  -webkit-box-orient: vertical;

  /* Line clamp (standard + vendor) */
  -webkit-line-clamp: 2;
  line-clamp: 2;

  overflow: hidden;
  word-break: break-word;
  min-height: 2.8em;
}

/* 空状态 */
.empty-state {
  grid-column: span 2;
  text-align: center;
  padding: 56px 20px;
  color: #8e8e93;
  font-size: 13px;
  font-weight: 500;
  background: transparent;
  border-radius: 0;
  margin-top: 10px;
}
</style>
